export const questionConstants = {

    FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
    FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
    FETCH_QUESTIONS_FAILURE: 'FETCH_QUESTIONS_FAILURE',

    CREATE_QUESTION_REQUEST: 'CREATE_QUESTION_REQUEST',
    CREATE_QUESTION_SUCCESS: 'CREATE_QUESTION_SUCCESS',
    CREATE_QUESTION_FAILURE: 'CREATE_QUESTION_FAILURE',

    UPDATE_QUESTION_REQUEST: 'UPDATE_QUESTION_REQUEST',
    UPDATE_QUESTION_SUCCESS: 'UPDATE_QUESTION_SUCCESS',
    UPDATE_QUESTION_FAILURE: 'UPDATE_QUESTION_FAILURE',

    DELETE_QUESTION_REQUEST: 'DELETE_QUESTION_REQUEST',
    DELETE_QUESTION_SUCCESS: 'DELETE_QUESTION_SUCCESS',
    DELETE_QUESTION_FAILURE: 'DELETE_QUESTION_FAILURE',

    UPDATE_QUESTIONSEQUENCE_REQUEST: 'UPDATE_QUESTIONSEQUENCE_REQUEST',
    UPDATE_QUESTIONSEQUENCE_SUCCESS: 'UPDATE_QUESTIONSEQUENCE_SUCCESS',
    UPDATE_QUESTIONSEQUENCE_FAILURE: 'UPDATE_QUESTIONSEQUENCE_FAILURE',

}